import { store } from '../store/index.js';

// Toast configuration based on type.
const toastConfigMap = {
  success: {
    color: 'success',
    icon: 'check_circle'
  },
  error: {
    color: 'error',
    icon: 'cancel'
  },
  info: {
    color: 'info',
    icon: 'info'
  },
  warn: {
    color: 'warning',
    icon: 'info'
  }
};

// Dispatch actions to the store for different types of toasts.
export const toast = Object.keys(toastConfigMap).reduce(
  (acc, type) => ({
    ...acc,
    [type]: (message, timeout = 6000) =>
      store.dispatch('addToast', {
        ...toastConfigMap[type],
        message,
        timeout,
        id: Math.floor(Math.random() * 1000),
        show: true
      })
  }),
  {}
);

export default defineNuxtPlugin(() => {
  window.$toast = toast;
  return {
    provide: {
      toast
    }
  };
});
